(function() {
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }
  
  function BulkSavingsPageATC() {
    document.addEventListener('click', function(e) {
      //console.log(e);
      if (e.target.matches('.shg-product-atc-btn-wrapper .shg-btn')) {
        //console.log(e);
        var $form = e.target.closest('form');
        // build: cart
        setTimeout(function() {
          document.dispatchEvent(new CustomEvent("cart:build", {detail: {}}));
        }, 1000);
      }
    }, false);
  }

  function groviaCustomSelect() {
    var container;
    var trigger;
    var selectedText;
    var optionsList;
    var options;
    var hiddenField;
    var isExpanded = false;
    var fancyStylingButton;

    window.addEventListener('DOMContentLoaded', function(e) {
      container = document.querySelector('.custom-select');
      if(!container) {
        return;
      }
      trigger = document.querySelector('.custom-select .trigger');
      selectedText = document.getElementById('selected-text');
      optionsList = document.querySelector('.custom-select .options');  
      options = document.querySelectorAll('.custom-select .options li');
      fancyStylingButton = document.getElementById('styling-toggle');
      hiddenField = document.getElementById('hidden-field');
      
      // Handle keyboard and mouse interactions on the trigger bar
      trigger.addEventListener('keydown', handleTriggerKeypresses);
      trigger.addEventListener('click', handleTriggerClick);
      
      // Select options when they are clicked
      options.forEach(function(option) {
        option.addEventListener('click', function(e) {
          unselectAllOptions();
          selectOption(e.target);
          collapseOptions();
          submitSelection();
          trigger.focus();
        });
      });
      
      // Collapse the dropdown when the user clicks off
      document.addEventListener('click', handleBodyClick);

    });


    /**
      Event handlers
    */
    function handleTriggerKeypresses(e) {
      switch(e.key) {
        case 'ArrowUp':
          e.preventDefault();
          if(isExpanded) {
            selectPreviousOption();
          } else {
            expandOptions();
          }
          
          break;
          
        case 'ArrowDown':
          e.preventDefault();
          if(isExpanded) {
            selectNextOption();
          } else {
            expandOptions();
            selectFirstOption();
          }
          
          break;
          
        case 'Home':
          if(isExpanded) {
            selectFirstOption();
          }
          
          break;
          
        case 'End':
          if(isExpanded) {
            selectLastOption();
          }
          
          break;
          
        case 'Tab':
          collapseOptions();
          break;
          
        case 'Escape':
          if(isExpanded) {
            e.preventDefault();
            collapseOptions();
          }
          
          break;
        case 'Enter':
          if(isExpanded) {
            e.preventDefault();
            collapseOptions();
            submitSelection();
          }
          
          break;
      }
    }

    function handleBodyClick(e) {
      if(!container.contains(e.target) && isExpanded) {
        collapseOptions();
      }
    }

    function handleTriggerClick() {
      if(isExpanded) {
        collapseOptions();
        trigger.focus();
      } else {
        expandOptions();
      }
    }


    /**
      Show/hide option list
    */
    function collapseOptions() {
      trigger.setAttribute('aria-expanded', false);
      optionsList.classList.remove('is-visible');
      isExpanded = false;
    }

    function expandOptions() {
      trigger.setAttribute('aria-expanded', true);
      optionsList.classList.add('is-visible');
      isExpanded = true;
    }


    /**
      Option selection
    */
    function selectFirstOption() {
      var firstOption = options[0];
      selectOption(firstOption);
    }

    function selectLastOption() {
      var lastOption = options[options.length-1];
      selectOption(lastOption);
    }

    function selectNextOption() {
      var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
      if(currentOption !== undefined) {
        var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
        if(currentOptionIndex + 1 < options.length) {
          var nextOption = options[currentOptionIndex + 1];
          selectOption(nextOption);
        }
      }
    }

    function selectPreviousOption() {
      var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
      
      if(currentOption !== undefined) {
        var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
        
        if(currentOptionIndex - 1 >= 0) {
          var previousOption = options[currentOptionIndex - 1];
          selectOption(previousOption);
        }
      }
    }

    function selectOption(option) {
      unselectAllOptions();
      option.setAttribute('aria-selected', true);
      trigger.setAttribute('aria-activedescendant', option.getAttribute('id'));
      selectedText.innerHTML = option.innerHTML;
      
      // Scroll item into view
      
      
      // Update the hidden field
      hiddenField.value = option.getAttribute('data-value');

      
    }

    function unselectAllOptions() {  
      options.forEach(function(option) {
        option.removeAttribute('aria-selected');
      });
    }


    function submitSelection() {
      this.queryParams = new URLSearchParams(window.location.search);

      this.queryParams.set('sort_by', hiddenField.value);
      this.queryParams.delete('page'); // Delete if it exists

      window.location.search = this.queryParams.toString();
    }
  }
  groviaCustomSelect();
  DOMready(function() {
    BulkSavingsPageATC();
  });
})();

// Prevent tabbing out of predictive search modal
function preventTabOutFromPredictiveModal() {
  var searchContainer = document.getElementById('site-header__search-container');
  var dialog = document.getElementById('PredictiveWrapper');
  var firstFocusableElement =  searchContainer.querySelector('.site-header__search-btn--submit') ;
  
  searchContainer.addEventListener('keydown', function(e) {
    var lastFocusableElement = dialog.classList.contains('hide') ? searchContainer.querySelector('#SearchClose') : dialog.querySelector('.ps-last-focusable-element');
    if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastFocusableElement.focus();
    } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  });
}
preventTabOutFromPredictiveModal();
